var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrangeBus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 80,
    viewBox: "0 0 61 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_15600)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5347 15.1744C47.893 14.1324 44.646 12.7875 41.3381 11.5398C38.0556 10.2944 34.7185 9.13644 32.8147 8.83591C31.3281 8.58045 30.2678 9.38957 29.7363 10.949L12.6325 56.0461C11.8346 58.0739 11.0974 60.0046 10.9272 60.9658C10.5608 63.1018 10.7205 64.7428 11.7344 65.4727C13.6012 66.8449 16.4625 68.2454 19.4237 69.3571C22.3789 70.4785 25.4473 71.333 27.7612 71.539C29.0091 71.6584 30.2191 70.5241 31.3588 68.6833C31.866 67.8521 32.6032 65.9214 33.3466 63.873L50.4503 18.7758C51.0752 17.2614 50.8203 15.9662 49.5408 15.1647L49.5347 15.1744Z",
    fill: "#F87E3A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8578 51.0735L18.2723 43.3181C18.7021 42.3303 19.1554 41.8437 19.3943 41.8718L20.1171 41.9461C20.2699 41.9607 20.1828 42.4874 19.9014 43.2167L19.3214 44.7458C18.6878 46.4035 18.1215 47.7383 17.5947 48.6654L15.9242 51.6335C15.558 52.2827 15.2334 52.7146 15.0601 52.6466L14.511 52.4243C14.4019 52.3829 14.5973 51.6402 14.8481 51.0675L14.8578 51.0735Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7925 48.1545L16.178 48.2109L18.3199 43.3484C18.4721 42.9977 18.6534 42.6653 18.8735 42.3571C19.265 41.8183 19.3921 41.9385 20.0991 42.0165C20.2179 42.0639 19.935 42.968 19.8935 43.0772C19.2392 44.7895 18.614 46.52 17.8022 48.1606L17.7925 48.1545Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9458 48.7546L17.4936 48.697C16.8037 49.9274 16.1889 51.2319 15.3791 52.3737C15.0935 52.7219 15.0125 52.5495 14.5665 52.3782C14.4988 52.2277 14.8302 51.354 14.8802 51.2095L15.9555 48.7607L15.9458 48.7546Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4147 52.4048C14.3526 52.5686 14.2287 52.6802 13.9398 52.7966C13.4688 52.9882 13.3419 52.76 12.9821 52.494C12.6029 52.2159 12.644 52.3228 12.327 51.8809C12.1418 51.6162 12.1774 51.4087 12.2992 51.1065C12.3613 50.9427 12.5459 50.842 12.6913 50.9331L14.2359 52.0224C14.3812 52.1135 14.4647 52.2604 14.4086 52.4145L14.4147 52.4048Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4066 52.44C14.3348 52.5978 14.1793 52.7167 13.9438 52.8125C13.8686 52.8464 13.8055 52.861 13.7327 52.8694C13.9807 53.2276 14.5889 53.6356 14.7204 53.3395C14.8531 53.0847 14.8557 52.9512 14.8681 52.8237C14.8987 52.6672 14.6297 52.4717 14.3908 52.4437L14.4066 52.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6512 42.1094L18.5147 42.4564C18.4197 42.6943 18.3042 42.8787 18.2593 42.8641L17.932 42.7402C17.8872 42.7256 17.913 42.512 18.008 42.2742L18.1445 41.9271C18.2395 41.6893 18.355 41.5048 18.3999 41.5194L18.7272 41.6433C18.7817 41.664 18.7462 41.8715 18.6512 42.1094Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1619 41.6139L20.8928 41.5264C19.4806 45.2241 18.1684 48.6329 17.8654 49.1595L17.8751 49.1656C16.4818 51.8206 14.9494 53.4694 14.427 55.359C14.0669 56.6879 14.7051 57.2634 15.4404 57.7917C17.6561 59.3825 19.9501 60.5898 22.3853 61.5071C24.8204 62.4244 27.3118 63.0796 30.0429 63.3307C30.9439 63.4221 31.8039 63.4066 32.4174 62.1689C33.2864 60.4154 33.2273 58.1615 33.9564 55.2525L36.7498 47.5405L36.477 47.4372L33.7323 55.0716C30.9486 54.4091 28.2778 53.6956 25.7045 52.7187C23.1311 51.7419 20.6613 50.492 18.1481 49.1608C18.4823 48.7349 19.3768 46.2945 21.1461 41.6176L21.1619 41.6139Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8624 54.8464C29.1672 54.1717 26.4966 53.3502 23.9356 52.2459C22.4168 51.6324 20.9093 50.8502 19.4442 50.108C18.9643 49.8615 18.4905 49.6052 18.0264 49.355C17.0992 51.072 15.892 52.6542 15.0229 54.4077C14.6516 55.2159 14.2727 56.2085 14.8814 56.9819C15.3051 57.4906 16.0575 57.9485 16.6136 58.3104C20.5656 60.9214 25.344 62.6443 30.0615 63.0855C30.6885 63.1404 31.2573 63.1588 31.7529 62.7124C32.5707 61.8595 32.8209 60.232 33.0121 59.1082C33.1901 57.8545 33.3889 56.5462 33.704 55.3107C33.5974 55.2439 33.2978 55.205 33.173 55.1673C32.751 55.0652 32.3037 54.9606 31.8781 54.8427L31.8624 54.8464Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8196 62.8606L27.6799 64.2158C27.7405 64.2268 27.7694 64.353 27.7304 64.4368L27.2498 65.3117C27.1926 65.4245 27.07 65.4694 27.0252 65.4548L22.4559 64.1737C22.411 64.1592 22.3797 64.0584 22.4053 63.9528L22.6653 63.0208C22.691 62.9152 22.7651 62.84 22.8196 62.8606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3909 61.1711C12.1417 60.429 10.975 61.0634 11.6921 62.9995C11.9251 63.6186 12.7221 64.9965 14.8457 65.7862C14.9654 64.6041 14.4269 61.7796 13.397 61.1614L13.3909 61.1711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8559 15.0006L40.8644 14.6227C40.7359 14.5693 40.645 14.4989 40.6597 14.454L40.7011 14.3447C40.7157 14.2998 40.8334 14.306 40.9619 14.3594L41.9534 14.7373C42.0819 14.7907 42.1727 14.8611 42.1581 14.906L42.1166 15.0153C42.102 15.0602 41.9844 15.054 41.8559 15.0006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.1285 16.6678C47.491 16.8003 47.8123 16.8259 47.8416 16.7361L48.1584 15.9072C48.1937 15.8077 47.9436 15.259 47.597 15.123C44.9307 13.8852 43.0267 13.0033 41.0631 12.2597C39.1188 11.5283 37.0919 10.9073 34.2684 10.0711C33.9254 9.95084 33.3731 10.1861 33.3377 10.2856L33.021 11.1144C32.9917 11.2042 33.2412 11.3876 33.5976 11.5298C35.9094 12.2346 38.1933 12.9625 40.4745 13.8239C42.7557 14.6853 44.9556 15.5904 47.1346 16.6581L47.1285 16.6678Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.098 15.8963C48.1069 15.6451 47.7764 15.2893 47.5764 15.1776C45.7306 14.3321 43.8728 13.398 41.9637 12.6751C39.4778 11.6449 36.8288 10.9181 34.2637 10.1221C34.0406 10.0905 33.559 10.1267 33.3961 10.322L33.0854 11.1412C33.4256 11.503 34.2525 11.6696 34.7071 11.8057C36.9207 12.5166 39.1913 13.2226 41.3427 14.0973C43.316 14.847 45.254 15.6961 47.1616 16.5938C47.3604 16.6643 47.581 16.7214 47.7933 16.7057L48.104 15.8866L48.098 15.8963Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5351 15.1747C50.8146 15.9763 51.0731 17.2872 50.4385 18.7956L50.3557 19.014L48.1881 18.359L49.3498 15.7075C47.6004 14.5574 44.4565 13.1555 41.2225 11.9406C38.0395 10.7305 34.7749 9.67204 32.614 9.37262L31.7153 12.1213L29.6538 11.1678L29.7306 10.959C30.256 9.40932 31.3224 8.59049 32.809 8.84595C34.7127 9.14648 38.0438 10.3142 41.342 11.5559C44.0887 12.6007 47.0695 13.6166 49.5351 15.1747Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8554 65.4682L14.8748 65.4803L14.8601 65.5252C14.8565 65.5094 14.8529 65.4937 14.859 65.484L14.8554 65.4682ZM25.3827 69.4545C25.3766 69.4642 25.3644 69.4836 25.3584 69.4933L25.373 69.4484L25.3827 69.4545ZM30.5781 68.4649C30.4974 68.8739 30.1448 69.3289 29.397 69.7255C28.8082 70.019 27.33 70.5257 25.2512 69.7506L25.2305 69.8052C23.5932 69.7256 21.8424 69.3317 19.9612 68.5858L19.9673 68.5761C19.9515 68.5797 19.9418 68.5736 19.9321 68.5675C19.7843 68.502 19.64 68.4521 19.4922 68.3865L19.48 68.4059C17.5878 67.7207 15.9955 66.8583 14.7286 65.8213L14.7554 65.757C12.6791 64.9563 11.9148 63.6125 11.666 62.997C11.3678 62.2019 11.4028 61.6291 11.6217 61.2796L11.0703 60.2854C11.0044 60.5414 10.9409 60.772 10.9079 60.9541C10.5415 63.09 10.6915 64.725 11.7151 65.4609C13.5855 66.8489 16.4432 68.2336 19.408 69.3611C19.488 69.3842 19.5619 69.417 19.6359 69.4498L19.642 69.4401C22.5293 70.519 25.4789 71.3261 27.7322 71.5211C28.9801 71.6406 30.184 70.5159 31.3176 68.6849C31.421 68.5199 31.5233 68.3136 31.6401 68.0624L30.5745 68.4491L30.5781 68.4649Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.9396 58.6805L37.5262 50.6091C37.8567 49.5861 37.8445 48.9161 37.647 48.7789L37.0607 48.3575C36.9408 48.2689 36.655 48.7251 36.3735 49.4544L35.7935 50.9835C35.1599 52.6412 34.7124 54.0234 34.4838 55.0562L33.7661 58.3778C33.6083 59.1036 33.5662 59.6449 33.7456 59.7032L34.2971 59.9C34.4062 59.9413 34.7494 59.2642 34.936 58.6647L34.9396 58.6805Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6822 54.5453L35.8495 55.6551L37.4715 50.5885C37.5885 50.2293 37.6765 49.8519 37.7233 49.4756C37.7875 48.813 37.6225 48.8177 37.0301 48.4061C36.9113 48.3587 36.529 49.2276 36.4875 49.3368C35.8332 51.0491 35.1535 52.7589 34.6883 54.5356L34.6822 54.5453Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.6657 56.2291L34.5407 55.1593C34.2424 56.5404 33.8361 57.9215 33.6905 59.3172C33.6679 59.7626 33.8439 59.6971 34.2961 59.8587C34.4466 59.7908 34.778 58.9171 34.8377 58.7787L35.6596 56.2388L35.6657 56.2291Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3817 59.9801C34.3196 60.144 34.3399 60.3054 34.4716 60.5907C34.694 61.0544 34.9452 60.955 35.3879 61.0025C35.862 61.0427 35.7589 61.0997 36.2855 60.9701C36.607 60.8876 36.7007 60.7165 36.8286 60.4047C36.8908 60.2408 36.8184 60.0333 36.6559 60.0126L34.7799 59.797C34.6174 59.7763 34.4438 59.8163 34.3878 59.9704L34.3817 59.9801Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3705 59.9996C34.3144 60.1537 34.3553 60.3685 34.4725 60.5907C34.5064 60.6659 34.5427 60.7157 34.5887 60.7716C34.1725 60.8758 33.4364 60.7796 33.5388 60.4653C33.6169 60.1898 33.6996 60.0794 33.7665 59.9726C33.8516 59.8367 34.1827 59.8684 34.3705 59.9996Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.0443 49.4599L37.9079 49.807C37.8129 50.0448 37.787 50.2584 37.8319 50.273L38.1592 50.3969C38.204 50.4115 38.3232 50.2428 38.4146 49.9892L38.551 49.6421C38.646 49.4043 38.6719 49.1907 38.627 49.1761L38.2998 49.0522C38.2452 49.0315 38.1357 49.2063 38.0443 49.4599Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.3432 67.2046C30.7764 67.4806 31.2267 68.7224 29.4093 69.706C28.818 70.025 27.3107 70.5135 25.1992 69.7044C25.8995 68.7373 28.1719 66.9844 29.3529 67.2106L29.3432 67.2046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2971 65.5824C15.2809 65.8021 15.3159 65.9186 15.4478 66.0959C15.5398 66.2076 15.6814 66.3909 16.0123 66.5306C16.8761 67.1123 18.3013 67.7889 19.774 68.3466C21.2468 68.9042 22.7659 69.3017 23.7868 69.4817C24.1105 69.5899 24.3447 69.5608 24.4963 69.5342C24.7208 69.4991 24.8203 69.4263 24.9456 69.2479C23.2248 69.0215 21.5858 68.5354 19.9954 67.9716C18.3251 67.3847 16.6662 66.4131 15.3007 65.5982L15.2971 65.5824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7822 68.3115C19.4101 68.173 19.1472 67.9677 19.1887 67.8585C19.2301 67.7493 19.5672 67.7713 19.9394 67.9098C20.3115 68.0483 20.5743 68.2535 20.5329 68.3627C20.4915 68.472 20.1543 68.45 19.7822 68.3115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7094 12.1311L21.4989 38.8784",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4987 38.8785C21.1794 39.7328 20.9251 40.1818 20.7615 40.1198",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7613 40.1198L20.2158 39.9133",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2159 39.9131C20.0971 39.8658 19.9785 39.7104 20.0557 39.2856",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.056 39.2856L20.343 37.4918",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3431 37.4919C20.4706 36.7067 20.5244 36.4701 21.1068 34.9155",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.1163 34.9216L30.1036 11.3549",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2095 11.9188L40.1202 14.7778",
    stroke: "white",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4632 44.1114L18.708 40.0364",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1982 18.3651C42.9266 15.6844 37.4272 13.6043 31.6963 12.1092",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0364 12.147L20.8887 41.5107",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3099 12.2502L21.1621 41.6139",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.156 18.3663L38.0704 45.1513",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0708 45.1513C37.7516 46.0056 37.6319 46.4983 37.7955 46.5603",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7959 46.5603L38.3256 46.7705",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3252 46.7704C38.444 46.8178 38.6333 46.7742 38.8644 46.4053",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.874 46.4115L39.8507 44.8741",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.8504 44.874C40.27 44.2042 40.4038 43.9906 40.9863 42.4361",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.98 42.4458L49.8775 18.85",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1937 11.9224L40.1105 14.7718",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.6201 43.7992L39.3753 47.8742",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.9095 18.1575L36.7617 47.5212",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.637 18.0542L36.4892 47.4179",
    stroke: "#FEFEFE",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8555 65.2521C16.4098 66.3475 18.168 67.3543 20.4506 68.149",
    stroke: "white",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.4926 69.2797C23.6008 69.0678 21.6244 68.6677 19.3857 67.7383",
    stroke: "white",
    strokeWidth: 0.00627831,
    strokeMiterlimit: 22.9256
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9687 19.7841L31.6338 14.0038L31.0883 15.4484L46.4233 21.2287L46.9687 19.7841Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.8262 25.4589L29.4912 19.6786L28.9457 21.1232L44.2807 26.9035L44.8262 25.4589Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.6836 31.1339L27.3486 25.3536L26.8032 26.7981L42.1381 32.5784L42.6836 31.1339Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.541 36.8087L25.2061 31.0284L24.6606 32.4729L39.9955 38.2532L40.541 36.8087Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3984 42.4835L23.0635 36.7032L22.518 38.1478L37.853 43.9281L38.3984 42.4835Z",
    fill: "#FEFEFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_15600",
    x: 2.72656,
    y: 0.789368,
    width: 56.0508,
    height: 78.7582,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.59 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_15600"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_15600",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrangeBus);
export default __webpack_public_path__ + "static/media/orangeBus.51f40fc9e018a4421c44b39138fde20c.svg";
export { ForwardRef as ReactComponent };